import { FC, memo } from 'react'
import styled from 'styled-components'

import MobileBaseCurrencyCard from './MobileBaseCurrencyCard'
import MobileQuoteCurrencyCard from './MobileQuoteCurrencyCard'
import MobileFeeTierSelector from './MobileFeeTierSelector'
import ListPairButton from './ListPairButton'
import MobileInitialPriceInput from './MobileInitialPriceInput'

const MobileSwap: FC = memo(() => (
	<MobileSwapContainer>
		<MobileBaseCurrencyCard />
		<MobileQuoteCurrencyCard />
		<MobileFeeTierSelector />
		<MobileInitialPriceInput />
		<ListPairButton />
	</MobileSwapContainer>
))

const MobileSwapContainer = styled.div`
	padding: 15px;
`

export default MobileSwap
